module.exports = __webpack_public_path__ + "24f77db4e09bb327b5c4fd2f2311fb4a.svg";